module.exports = __webpack_public_path__ + "img/outside_temp.2e52fd06.svg";